import axios from './axiosInstances/axiosInstance';

const URI = '/restaurants';

export const restaurantDisclaimers = (restaurantId) => {
  return axios.get(`${URI}/${restaurantId}/disclaimers`);
};
